import Formio from 'formiojs/Formio';
import { detectAllowedEntityTypes } from '../../utils/component-finder/component-finder';

export async function getEntityTypes(componentForm: HTMLFormElement) {
	const formio = new Formio(Formio.getProjectUrl() + '/form/' + componentForm);
	const form = await formio.loadForm({ params: { live: 1 } });
	return detectAllowedEntityTypes(form.components ?? []);
}
